import { DataGrid } from '@tableau/widgets-datagrid';
import * as _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { CommonDataGridColumns } from '../../common/react/CommonDataGridColumns';
import { DataGridCells } from '../../common/react/components/dataGrid/DataGridCells';
import { SortableHeader } from '../../common/react/components/dataGrid/SortableHeader';
import { FlowOutputStepInfo } from '../../ts/models/FlowOutputStepInfo';
import { RunFlowTaskInfo } from '../../ts/models/RunFlowTaskInfo';

export type FlowScheduledTasksGridRow = {
  readonly outputStepName: string;
  readonly outputName: string;
  readonly outputType: string;
  readonly outputLocation: string;
};

export module FlowScheduledTasksGrid {
  export function columns() : DataGrid.Column[] {

    const outputStepColumn: DataGrid.Column = CommonDataGridColumns.withExtraSpace(
      {
        name: 'output-step-col',
        dataKey: 'outputStepName',
        sortable: false,
        headerText: Messages.flowRunHistoryColumn_output(),
        direction: 'desc',
        headerFormatter: SortableHeader.Formatter(),
        cellFormatter: DataGridCells.PlainTextCell('outputStepName')
      },
    );

    const outputNameColumn: DataGrid.Column = {
      name: 'output-name-col',
      dataKey: 'outputName',
      sortable: false,
      preferredWidth: 300,
      headerText: Messages.flowOverviewOutputName(),
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCell('outputName')
    };

    const outputTypeColumn: DataGrid.Column = {
      name: 'output-type-col',
      dataKey: 'outputType',
      sortable: false,
      headerText: Messages.flowScheduledTaskType(),
      direction: 'desc',
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCell('outputType')
    };

    const outputLocationColumn: DataGrid.Column = {
      name: 'output-location-col',
      dataKey: 'outputLocation',
      sortable: false,
      headerText: Messages.flowScheduledTaskLocation(),
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCell('outputLocation')
    };

    return _.compact([
      outputStepColumn,
      outputNameColumn,
      outputTypeColumn,
      outputLocationColumn,
    ]);
  }

}
